<template>
  <v-container fluid class="oauth-callback-container fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="auto" class="text-center">
        <v-progress-circular indeterminate color="#111010" :size="48" />
        <p class="mt-4 outfit-bold text-16 text-light-black">Signing you in...</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "OAuthCallback",
  async mounted() {
    const { code, state, error, error_description } = this.$route.query;

    if (error) {
      this.$store.dispatch("showMessage", {
        message: error_description || error,
        messageType: "error",
        messageTitle: "Sign-in Failed",
      });
      this.$router.push("/login").catch(() => {});
      return;
    }

    if (!code) {
      this.$store.dispatch("showMessage", {
        message: "No authorization code received. Please try again.",
        messageType: "error",
        messageTitle: "Sign-in Failed",
      });
      this.$router.push("/login").catch(() => {});
      return;
    }

    const savedState = sessionStorage.getItem("oauth_state");
    if (state !== savedState) {
      this.$store.dispatch("showMessage", {
        message: "OAuth state mismatch. Please try again.",
        messageType: "error",
        messageTitle: "Sign-in Failed",
      });
      this.$router.push("/login").catch(() => {});
      return;
    }

    const provider = sessionStorage.getItem("oauth_provider") || "google";

    const storedRedirect = sessionStorage.getItem("oauth_redirect");
    const rawQueryRedirect = this.$route.query.redirect;
    let queryRedirect = "";
    if (typeof rawQueryRedirect === "string") {
      queryRedirect = rawQueryRedirect;
    } else if (Array.isArray(rawQueryRedirect) && rawQueryRedirect[0]) {
      queryRedirect = rawQueryRedirect[0];
    }
    const redirectUrl = storedRedirect || queryRedirect || "/";

    await this.$store.dispatch("login/loginWithOAuth", {
      code,
      provider,
      redirectUrl,
    });
  },
};
</script>

<style scoped lang="scss">
.oauth-callback-container {
  background-color: #ffffff;
  min-height: 100vh;
}
</style>
